var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var STORAGE_PREFIX = "participe.hearingCommentSupports";
var storageKey = function (userId) { return "".concat(STORAGE_PREFIX, ".").concat(userId); };
var collectCommentIds = function (comments, bucket) {
    if (bucket === void 0) { bucket = new Set(); }
    comments.forEach(function (comment) {
        var _a;
        bucket.add(comment.id);
        if ((_a = comment.childrenComments) === null || _a === void 0 ? void 0 : _a.length) {
            collectCommentIds(comment.childrenComments, bucket);
        }
    });
    return bucket;
};
var readUserStore = function (userId) {
    if (typeof window === "undefined") {
        return {};
    }
    try {
        var raw = window.localStorage.getItem(storageKey(userId));
        if (!raw) {
            return {};
        }
        var parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : {};
    }
    catch (_a) {
        return {};
    }
};
var writeUserStore = function (userId, store) {
    if (typeof window === "undefined") {
        return;
    }
    window.localStorage.setItem(storageKey(userId), JSON.stringify(store));
};
export var buildSupportsMapFromComments = function (comments) {
    var supports = {};
    var visit = function (nodes) {
        nodes.forEach(function (comment) {
            var _a;
            if (typeof comment.currentUserSupportId === "number") {
                supports[comment.id] = comment.currentUserSupportId;
            }
            if ((_a = comment.childrenComments) === null || _a === void 0 ? void 0 : _a.length) {
                visit(comment.childrenComments);
            }
        });
    };
    visit(comments);
    return supports;
};
export var loadStoredHearingSupports = function (userId, hearingId, comments) {
    var hearingKey = String(hearingId);
    var stored = readUserStore(userId)[hearingKey] || {};
    var commentIds = collectCommentIds(comments);
    var supports = {};
    Object.entries(stored).forEach(function (_a) {
        var commentId = _a[0], supportId = _a[1];
        var normalizedCommentId = Number(commentId);
        if (commentIds.has(normalizedCommentId) &&
            typeof supportId === "number" &&
            Number.isFinite(supportId)) {
            supports[normalizedCommentId] = supportId;
        }
    });
    return supports;
};
export var persistHearingSupport = function (userId, hearingId, commentId, supportId) {
    var _a;
    var store = readUserStore(userId);
    var hearingKey = String(hearingId);
    store[hearingKey] = __assign(__assign({}, (store[hearingKey] || {})), (_a = {}, _a[String(commentId)] = supportId, _a));
    writeUserStore(userId, store);
};
export var clearPersistedHearingSupport = function (userId, hearingId, commentId) {
    var store = readUserStore(userId);
    var hearingKey = String(hearingId);
    var hearingSupports = __assign({}, (store[hearingKey] || {}));
    delete hearingSupports[String(commentId)];
    if (Object.keys(hearingSupports).length === 0) {
        delete store[hearingKey];
    }
    else {
        store[hearingKey] = hearingSupports;
    }
    writeUserStore(userId, store);
};
export var mergeHearingUserSupports = function (base, overrides) {
    var merged = __assign({}, base);
    Object.entries(overrides).forEach(function (_a) {
        var commentId = _a[0], supportId = _a[1];
        var normalizedCommentId = Number(commentId);
        if (supportId === null) {
            delete merged[normalizedCommentId];
            return;
        }
        merged[normalizedCommentId] = supportId;
    });
    return merged;
};
